<template>
  <div ref="cell" class="grid-view__cell grid-field-many-to-many__cell active">
    <div ref="dropdownLink" class="grid-field-many-to-many__list">
      <div
        v-for="item in value"
        :key="item.id"
        class="field-multiple-collaborators__item"
      >
        <template v-if="item.id && item.name">
          <div
            class="field-multiple-collaborators__name background-color--light-gray"
          >
            <span class="field-multiple-collaborators__name-text">
              <SearchHighlightedText
                :text="getCollaboratorName(item)"
                :search-term="searchTerm"
              />
            </span>
            <!--
              `button` rather than an `<a>` without an `href`, which is neither
              focusable nor exposed with a role.
            -->
            <button
              v-if="!readOnly"
              type="button"
              class="grid-field-many-to-many__remove"
              :aria-label="
                $t('gridViewFieldMultipleCollaborators.removeCollaborator', {
                  value: getCollaboratorName(item),
                })
              "
              @click.prevent="removeValue($event, value, item.id)"
            >
              <i class="iconoir-cancel"></i>
            </button>
          </div>
          <div class="field-multiple-collaborators__initials">
            {{ getCollaboratorNameInitials(item) }}
          </div>
        </template>
      </div>
      <button
        v-if="!readOnly"
        type="button"
        class="grid-field-many-to-many__item grid-field-many-to-many__item--link"
        :aria-label="$t('gridViewFieldMultipleCollaborators.addCollaborator')"
        @click.prevent="toggleDropdown()"
      >
        <i class="iconoir-plus"></i>
      </button>
    </div>
    <FieldCollaboratorDropdown
      v-if="!readOnly"
      ref="dropdown"
      :collaborators="availableCollaborators"
      :show-input="false"
      :show-empty-value="false"
      class="dropdown--floating"
      @show="editing = true"
      @hide="editing = false"
      @input="updateValue($event, value)"
    ></FieldCollaboratorDropdown>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import collaboratorField from '@baserow/modules/database/mixins/collaboratorField'
import FieldCollaboratorDropdown from '@baserow/modules/database/components/field/FieldCollaboratorDropdown'
import collaboratorName from '@baserow/modules/database/mixins/collaboratorName'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  components: { FieldCollaboratorDropdown, SearchHighlightedText },
  mixins: [gridField, collaboratorField, collaboratorName],
  emits: ['editing-changed'],
  data() {
    return {
      editing: false,
    }
  },
  watch: {
    editing(editing) {
      this.$emit('editing-changed', editing)
    },
  },
}
</script>
